var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export const SYSTEM_PERSON_PROFILE_URL = "https://d1g4tra87tz2vv.cloudfront.net/web/images/0/no-photo-avatar.png";
const profilePictureSizeBreakPoint = 40;
const Picture = (props) => {
    let imageStyle = {};
    let imageClass = (props.className || "") + " rounded-circle av-profile-image";
    if (typeof props.size === "number") {
        imageStyle = { width: props.size, height: props.size };
        if (props.size < 40) {
            imageStyle = Object.assign(Object.assign({}, imageStyle), { fontSize: props.size / 2 });
        }
        if (props.size > profilePictureSizeBreakPoint) {
            imageClass += "-lg";
        }
    }
    else if (props.size === "lg") {
        imageClass += "-lg";
    }
    if (props.url) {
        return (_jsx("img", { className: imageClass, src: props.url, alt: props.person.fullName, title: props.title ? props.title : props.person.fullName, style: imageStyle }));
    }
    return (_jsx("div", { className: imageClass +
            " d-flex justify-content-center align-items-center flex-column", style: Object.assign(Object.assign({}, imageStyle), { backgroundColor: props.person.initialsBackgroundColorHex }), children: _jsxs("span", { title: props.person.fullName, children: [props.person.firstName[0], props.person.lastName[0]] }) }));
};
export const SystemPicture = (_a) => {
    var { firstName, lastName } = _a, others = __rest(_a, ["firstName", "lastName"]) // @ts-expect-error - TS2344 - Type 'PictureProps' does not satisfy the constraint '{ person: PersonPattern; url: string | null | undefined; }'.
    ;
    const fn = firstName || "";
    const ln = lastName || "System";
    const fullName = fn + " " + ln;
    return (_jsx(Picture, Object.assign({ person: {
            firstName: fn,
            lastName: ln,
            fullName,
            initialsBackgroundColorHex: "#222",
            smallPhotoUrl: SYSTEM_PERSON_PROFILE_URL,
            largePhotoUrl: SYSTEM_PERSON_PROFILE_URL,
        }, url: SYSTEM_PERSON_PROFILE_URL }, others)));
};
const ProfilePicture = (props) => {
    // set url to null if showProfilePicture is false, otherwise return photoUrl or smallPhotoUrl if photoUrl is undefined.
    let url = null;
    if (props.showProfilePicture) {
        if (props.photoUrl) {
            url = props.photoUrl;
        }
        // If large is selected and the person has a large photo url, use that one.
        else if (props.person.largePhotoUrl &&
            (props.size === "lg" ||
                (typeof props.size === "number" &&
                    props.size > profilePictureSizeBreakPoint))) {
            url = props.person.largePhotoUrl;
        }
        else {
            url = props.person.smallPhotoUrl;
        }
    }
    if (props.profileUrl) {
        return (
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        _jsx("a", { href: props.profileUrl, className: props.className, children: _jsx(Picture, { person: props.person, url: url, size: props.size, title: props.title }) }));
    }
    return (_jsx(Picture, { person: props.person, url: url, size: props.size, className: props.className, title: props.title }));
};
export default ProfilePicture;
